import {DrawerProps} from '@mantine/core';
import {useParams} from "react-router-dom";
import {FormDrawer} from "./FormDrawer.tsx";
import {useApplication} from "../hooks/useApplication.ts";


export const EditFormDrawer = (props: DrawerProps) => {

    const {id: applicationId} = useParams();

    if (typeof applicationId === 'undefined') {
        throw new Error('applicationId is required parameter');
    }

    const {
        record,
        updateRecord,
    } = useApplication(applicationId);

    if (!record) return null;

    return (
        <FormDrawer
            record={record}
            handleSubmit={updateRecord}
            {...props}
        />
    )
};
